import '../../../assets/css/earthwooduser.css';
import React, { useEffect, useState } from "react";
import Leftbar from "../../../elements/Leftbar";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../../config/global_constants';
import { Box } from '@mui/material';
import Select from "react-select";
import { callBackendAPI } from '../../../helpers/common';
import "../BulkEmail.css";
import { Col, Container, Row } from 'react-bootstrap';
import AssignTemplateUserDetails from '../AssignTemplateUserDetails/AssignTemplateUserDetails';

const AssignTemplateUser = () => {
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [userstemplate, setUsersTemplate] = useState([]);
  const [selectedUserTemplate, setSelectedUserTemplate] = useState(null);


  const handleSidebarClose = () => setShowSidebar(false);


  const customSelectStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: '38px',
    }),
  };


  const fetchTemplateUser = async () => {
    const apiParams = {
      request_type: "get",
      method: "bulkEmail/getDropdownValue",
    };
    try {
      const response = await callBackendAPI([apiParams]);
      // console.log(response?.data[0]?.emailUsers,"response......")
      if (response.success) {
        setUsers(response?.data[0]?.emailUsers)
        setUsersTemplate(response?.data[0]?.templates || []);


      }

    } catch (err) {
      console.error("Error fetching templates:", err);
    }
  };

  useEffect(() => {
    fetchTemplateUser();
  }, []);


  const AssignTemplate = async (e) => {
    e.preventDefault();

    if (!selectedUser) {
      toast.error("Please select a user");
      return;
    }
    if (!selectedUserTemplate) {
      toast.error("Please select a template");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        email_template_id: selectedUserTemplate,
        email_user_id: selectedUser,
      };

      const response = await axios.post(
        `${API_URL}bulkEmail/assignTemplateToUser`,
        payload,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          }
        }
      );

      toast.success(response?.data?.message || "Assign Template successfully!");

      setSelectedUser(null);
      setSelectedUserTemplate(null);
      setTimeout(() => {
        window.location.href = "/assign-templateuser"
      }, [1200])

    } catch (error) {
      console.error("Error assigning template:", error);
      toast.error(error.response?.data?.message || "An error occurred while assigning the template.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="earthwood-layout">
      <div className="leftbar-wrapper">
        <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="earthwood-user-list w-100">
            <div className="container-fluid Contrcat-conatiner">
              <div className="row">
                <Col xs={12}>
                  <div className="card mb-4">
                    <div className="card-header">
                      <h5 className="mb-0">Assign Template User</h5>
                    </div>
                    <Row>
                      {/* User Dropdown */}
                      <Col md={6}>
                        <div className="card-body">
                          <Box mt={2}>
                            <Select
                              options={users.map(user => ({
                                value: user.id,
                                label: `${user.first_name} (${user.email})`
                              }))}
                              value={
                                selectedUser
                                  ? {
                                    value: selectedUser,
                                    label: `${users.find(u => u.id === selectedUser)?.first_name} (${users.find(u => u.id === selectedUser)?.email})`
                                  }
                                  : null
                              }
                              onChange={(option) => setSelectedUser(option?.value || null)}
                              placeholder="Select a user..."
                              styles={customSelectStyles}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              maxMenuHeight={300}
                            />
                          </Box>
                        </div>
                      </Col>

                      {/* Template Dropdown */}
                      <Col md={6}>
                        <div className="card-body">
                          <Box mt={2}>
                            <Select
                              options={userstemplate.map(temp => ({
                                value: temp.id,
                                label: temp.title
                              }))}
                              value={
                                selectedUserTemplate
                                  ? {
                                    value: selectedUserTemplate,
                                    label: userstemplate.find(t => t.id === selectedUserTemplate)?.title
                                  }
                                  : null
                              }
                              onChange={(option) => setSelectedUserTemplate(option?.value || null)}
                              placeholder="Select a Template..."
                              isClearable
                              styles={customSelectStyles}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              maxMenuHeight={300}
                            />
                          </Box>
                        </div>
                      </Col>


                    </Row>

                    <button
                      onClick={AssignTemplate}
                      disabled={loading}
                      className="btn submit-btn-template w-15 mx-lg-2 mb-2"
                    >
                      {loading && <i className="pi pi-spin pi-spinner" style={{ marginRight: '8px' }}></i>}
                      <span>{loading ? "Submitting..." : "Submit"}</span>
                    </button>
                  </div>
                </Col>
              </div>

              {/* Submit Button */}

            </div>

          </Col>


        </Row>
      </Container>
    </div>
  );
};

export default AssignTemplateUser;
